import * as React from 'react';
const SvgSquareInsetFillCenter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M8.055 8.273C8 8.38 8 8.52 8 8.8v6.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C8.38 16 8.52 16 8.8 16h6.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C16 15.62 16 15.48 16 15.2V8.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C15.62 8 15.48 8 15.2 8H8.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.161 4c-.527 0-.981 0-1.356.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C4 7.18 4 7.635 4 8.161v7.678c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h7.678c.527 0 .981 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V8.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 15.839 4zM6.546 6.109c.05-.025.15-.063.422-.085C7.25 6 7.623 6 8.2 6h7.6c.577 0 .949 0 1.232.024.272.022.372.06.422.085a1 1 0 0 1 .437.437c.025.05.063.15.085.422C18 7.25 18 7.623 18 8.2v7.6c0 .577 0 .949-.024 1.232-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C16.75 18 16.377 18 15.8 18H8.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C6 16.75 6 16.377 6 15.8V8.2c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSquareInsetFillCenter;
